export interface WriteAccessActions {
  /** Ответ в окне «может ли бот писать» (`app/asks.ts`). */
  answerWriteAccess(allow: boolean): void;
}

const noop = () => {};

export const defaults: WriteAccessActions = {
  answerWriteAccess: noop,
};

declare module "../actions" {
  interface WindowActions extends WriteAccessActions {}
}
